import React, { useEffect, useState } from "react";
import { Col, Row, Form, DatePicker, Select, message } from "antd";
import moment from "moment";
import ChronicConditionService from "../../../Services/ChronicConditionService";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

function AddChronicCondition(props) {
  const [form] = Form.useForm();
  const activePatient = JSON.parse(localStorage.getItem("patientData"));
  const patientCode = activePatient?.patientId;
  const [chronicValue, setChronicValue] = useState();
  const [chronicCode, setChronicCode] = useState([]);
  const [chronicDesc, setChronicDesc] = useState();
  const { patientData } = useSelector((state) => state.auth);
  const patientName = `${props.selectedPatient?.salutation || ""}${
    props.selectedPatient?.firstName || ""
  } ${props.selectedPatient?.lastName || ""}`.trim();
  const [disable, setDisable] = useState(false);

  const handleCancel = () => {
    props.onClose();
  };
  const handlehealthChange = (value, desc) => {
    setChronicValue(value);
    setChronicDesc(desc.description);
  };

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const healthConditions = [
    { name: "COPD", value: "COPD" },
    { name: "Asthma", value: "Asthma" },
    { name: "Diabetes Mellitus", value: "Diabetes Mellitus" },
    { name: "Hypertension", value: "Hypertension" },
    { name: "Congestive Heart Failure", value: "Congestive Heart Failure" },
    { name: "Cardiac Disease", value: "Cardiac Disease" },
    { name: "Renal Disease", value: "Renal Disease" },
    { name: "Chronic Renal Failure", value: "Chronic Renal Failure" },
    { name: "Rheumatoid Arthritis", value: "Rheumatoid Arthritis" },
    { name: "Organ Transplant", value: "Organ Transplant" },
    { name: "High Cholesterol", value: "High Cholesterol" },
    { name: "Psychiatric Disorder", value: "Psychiatric Disorder" },
    { name: "Neurological Disorder", value: "Neurological Disorder" },
    { name: "Oncological Disorders", value: "Oncological Disorders" },
  ];

  const ChronicCode = () => {
    let payload = {
      status: 1,
    };
    ChronicConditionService.chronicConditions(payload).then((result) => {
      setChronicCode(result.data);
    });
  };

  useEffect(() => {
    ChronicCode();
  }, []);

  const convertUTCDate = (date, format) => {
    if (!format) {
      const d = new Date();
      date = new Date(
        moment(date, "MM-DD-YYYY").format("MM/DD/YYYY") +
          " " +
          d.getHours() +
          ":" +
          d.getMinutes(),
      );
    }
    format = format || "MM/DD/YYYY";
    return moment(new Date(date)).utc().format(format);
  };

  const onFinish = (values) => {
    setDisable(true);
    if (!chronicDesc || !values.givenDate) {
      message.error("Please fill all fields");
      setDisable(false);
      return;
    }
    let payload = {
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      givenDate: dayjs(values.givenDate, "YYYY-MM-DD HH:mm:ss").format(
        "YYYY-MM-DD HH:mm:ss",
      ),
      createdBy: patientCode,
      modifiedBy: patientCode,
      status: 1,
      account_Id: patientData?.account_Id,
      clinic_Id: patientData?.clinic_Id,
      patientId: props.selectedPatient.patientId,
      chronicCode: chronicValue,
      chronicDescription: chronicDesc,
      createdName: `${activePatient?.salutation || ""}${
        activePatient?.firstName || ""
      } ${activePatient?.lastName || ""}`.trim(),
      patientName: patientName,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
    };
    ChronicConditionService.AddChronicConditions(payload)
      .then((result) => {
        props.onClose();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <div>
      <Form
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        form={form}
        onFinish={onFinish}
      >
        <div className="border rounded-lg p-2">
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label={
                  <span>
                    Chronic Condition{" "}
                    <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="pastInfo"
              >
                <Select
                  style={{ width: "100%" }}
                  onChange={handlehealthChange}
                  placeholder="Select"
                  value={chronicValue}
                  options={chronicCode.map((ele) => ({
                    value: ele.code,
                    description: ele.description,
                    label: ele.description,
                    key: ele.value,
                  }))}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={12}>
              <Form.Item
                label={
                  <span>
                    Date <span style={{ color: "#FF000F" }}>*</span>
                  </span>
                }
                name="givenDate"
              >
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder="Select"
                  format="MM-DD-YYYY"
                  disabledDate={disabledFutureDate}
                />
              </Form.Item>
            </Col>

            <Col span={24}>
              <div className="flex items-center w-full justify-end my-5 gap-3">
                <button
                  onClick={handleCancel}
                  className="border-[#189FAA] border rounded-sm text-[#189FAA] text-sm px-6 py-1.5"
                >
                  Cancel
                </button>
                <button
                  disabled={disable}
                  className="bg-secondaryColor border-brand-secondaryColor border rounded px-5 py-1.5 text-brand-white text-sm"
                >
                  Submit
                </button>
              </div>
            </Col>
          </Row>
        </div>
      </Form>
    </div>
  );
}

export default AddChronicCondition;
